import type { ComponentType, SVGProps } from 'react'

import type { ThemeId } from '../../theme/ThemeContext'
import {
  IconCartoon,
  IconCool,
  IconGeek,
  IconGlassLayers,
  IconIllustration,
  IconMoon,
  IconPixel,
  IconSun,
} from '../theme-icons'

/** 各主题对应线框图标（与 ThemeSegment / ThemeHeaderPicker 共用） */
export const THEME_SEGMENT_ICONS: Record<
  ThemeId,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  warm: IconSun,
  cool: IconCool,
  dark: IconMoon,
  glass: IconGlassLayers,
  cartoon: IconCartoon,
  illustration: IconIllustration,
  pixel: IconPixel,
  geek: IconGeek,
}
